import { get } from "@ember/object"

export function initialize(appInstance) {
  let session = appInstance.lookup("service:session")
  let socket = appInstance.lookup("service:socket")
  session.initiate()
  socket.initiate()
  let token = get(session, "token")

  let finder = appInstance.lookup("service:finder")
  // This is a messy and it knows more about the internals than I'd like.
  // I'm not sure the better way to do this at the moment, but if I have to employ this
  // pattern again, I should figure it out.
  // The session.get('user') triggers the observer on the session which identifies the
  // user in the analytics
  if (token) {
    socket
      .authenticateWithToken(token)
      .then((result) =>
        finder.insertResponseDocs(result, appInstance.lookup("adapter:user"), "user", [
          session.userId,
        ])
      )
      .then(() => session.sendUserToAnalytics())
      .catch((error) => console.error(error))
  }
}

export default {
  name: "session",
  initialize: initialize,
  before: ["app-state", "store", "socket", "ajax"],
}
